import { render, staticRenderFns } from "./externallinks.vue?vue&type=template&id=7f10cf46&scoped=true&"
import script from "./externallinks.vue?vue&type=script&lang=js&"
export * from "./externallinks.vue?vue&type=script&lang=js&"
import style0 from "./externallinks.vue?vue&type=style&index=0&id=7f10cf46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10cf46",
  null
  
)

export default component.exports